import React, { useState, useEffect,useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import HorizontalBarChart from '../chart/HorizontalBarChart';
import './EtatsGlobaux.css';
import { usePDF, Margin } from 'react-to-pdf';
import { Button } from 'primereact/button';
import { useReactToPrint } from 'react-to-print';
import ExportRapport from './ExportRapport';
import PieChartNew from '../chart/PieChartNew';

const EtatsTopConsommations = (props) => {
    const { t } = useTranslation();
    const { data, showLoading, clientIds, dateMin, dateMax, clientName, type,familleId  } = props;
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: `
        @media print {
          .p-datatable th, .p-datatable td {
            padding: 8px !important;
            font-size: 10px !important;
          }
        }
      `,
      // Ajoute une entête sur chaque page du PDF
      onBeforeGetContent: () => {
        const doc = document.querySelector('.p-datatable');
        if (doc) {
          // Applique des sauts de page personnalisés et autres styles
          let pageBreaks = document.querySelectorAll('.p-datatable-pagebreak');
          pageBreaks.forEach((breakElement) => breakElement.remove()); // Nettoie les sauts de page existants
          let rows = doc.querySelectorAll('.p-datatable-row');
          for (let i = 15; i < rows.length; i += 15) {
            let pageBreak = document.createElement('div');
            pageBreak.classList.add('p-datatable-pagebreak');
            rows[i].parentNode.insertBefore(pageBreak, rows[i]);
          }
        }
      },
    });
    const dt = useRef(null);

    const [statsDatas, setStatsDatas] = useState([]);
    const [dataAmbuSeries, setDataAmbuSeries] = useState([]);
    const [dataHospiSeries, setDataHospiSeries] = useState([]);
    const [dataAmbuLabels, setDataAmbuLabels] = useState([]);
    const [dataHospiLabels, setDataHospiLabels] = useState([]);
    const [graph, setGraph] = useState(false);
    const [bolPDF, setBolPDF] = useState(true);
    const [expandedRows, setExpandedRows] = useState(null);

    const [dataAmbuSerie2, setDataAmbuSerie2] = useState([]);
    const [dataHospiSerie2, setDataHospiSerie2] = useState([]);

    useEffect(() => {
        if(data.length > 0){
            setStatsDatas(data.map((key, i) => {
                return {
                    id: i,
                    statName: key.name,
                    numeroAdherentP: familleId?.length>0 ? "" : key.numeroAdherentP,
                    totalMontant: key["total"]["montant"],
                    totalPourcent: parseFloat(key["total"]["taux"]),
                    ambuMontant: key["ambulatoire"]["montant"],
                    ambuPourcent: parseFloat(key["ambulatoire"]["taux"]),
                    hospiMontant: key["hospitalier"]["montant"],
                    hospiPourcent: parseFloat(key["hospitalier"]["taux"]),
                    nombreBeneficiare:`${key.children?.length} membre(s)`,
                    children: key.children?.map((child, j) => {
                        return {
                            id: j,
                            statName: child.name,
                            totalMontant: child["total"]["montant"],
                            totalPourcent: parseFloat(child["total"]["taux"]),
                            ambuMontant: child["ambulatoire"]["montant"],
                            ambuPourcent: parseFloat(child["ambulatoire"]["taux"]),
                            hospiMontant: child["hospitalier"]["montant"],
                            hospiPourcent: parseFloat(child["hospitalier"]["taux"])
                        }
                    })
                }
            })) 

            let prestsAmbu = data.filter(elt => elt.ambulatoire.montant > 0);
            let prestsHospi = data.filter(elt => elt.hospitalier.montant > 0);
            
            setDataAmbuSeries([{
                data: prestsAmbu.map(key => {
                    return key["ambulatoire"]["montant"]
                })
            }]);
            
            setDataHospiSeries([{
                data: prestsHospi.map(key => {
                    return key["hospitalier"]["montant"]
                })
            }]);
            setDataAmbuLabels(prestsAmbu.map(key => key.name));
            setDataHospiLabels(prestsHospi.map(key => key.name));

            setDataHospiSerie2(
                prestsHospi.map(key => {
                        return key["hospitalier"]["montant"]
                    })
                );
    
                setDataAmbuSerie2(
                prestsAmbu.map(key => {
                        return  key["ambulatoire"]["montant"]
                    })
                );
        }
    }, [data]);

    const rowExpansionTemplate = (data) => {
        const childHeaderGroup = (
            <ColumnGroup>
                <Row>
                    <Column header={t("common.beneficiary")} rowSpan={2}/>
                    <Column header="Total" colSpan={2} />
                    <Column header={ t("common.ambulatory")} colSpan={2} />
                    <Column header={t("common.hospital")} colSpan={2} />
                </Row>
                <Row>
                    <Column header={t("facturation.amount")} field="totalMontant" />
                    <Column header={t("common.rate")} field="totalPourcen" />
                    <Column header={t("facturation.amount")} field="ambuMontant" />
                    <Column header={t("common.rate")} field="ambuPourcen" />
                    <Column header={t("facturation.amount")} field="hospiMontant" />
                    <Column header={t("common.rate")} field="hospiPourcen" />
                </Row>
            </ColumnGroup>
        );
        
        return (
            <div>
                <DataTable 
                    dataKey="id"
                    showGridlines 
                    headerColumnGroup={childHeaderGroup}
                    value={data.children}
                >
                    <Column field="statName"></Column>
                    <Column field="totalMontant"></Column>
                    <Column field="totalPourcent"></Column>
                    <Column field="ambuMontant"></Column>
                    <Column field="ambuPourcent"></Column>
                    <Column field="hospiMontant"></Column>
                    <Column field="hospiPourcent"></Column>
                </DataTable>
            </div>
        );
    };

    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header={type} rowSpan={2} colSpan={type === "Famille" && bolPDF ? 4 : 1} />
                <Column header="Total" colSpan={2} />
                <Column header="Ambulatoire" colSpan={2} />
                <Column header="Hospitalier" colSpan={2} />
              

            </Row>
            <Row>
                <Column header={t("facturation.amount")} field="totalMontant" />
                <Column header="Taux en %" field="totalPourcen" />
                <Column header={t("facturation.amount")} field="ambuMontant" />
                <Column header="Taux en %" field="ambuPourcen" />
                <Column header={t("facturation.amount")} field="hospiMontant" />
                <Column header="Taux en %" field="hospiPourcen" />
            </Row>
        </ColumnGroup>
    );
    const headerGroupExport = (
        <ColumnGroup>
            <Row>
                <Column header={type} rowSpan={2} colSpan={1} />
                <Column header="Total" colSpan={2} />
                <Column header="Ambulatoire" colSpan={2} />
                <Column header="Hospitalier" colSpan={2} />
            </Row>
            <Row>
                <Column header={t("facturation.amount")} field="totalMontant" />
                <Column header="Taux en %" field="totalPourcen" />
                <Column header={t("facturation.amount")} field="ambuMontant" />
                <Column header="Taux en %" field="ambuPourcen" />
                <Column header={t("facturation.amount")} field="hospiMontant" />
                <Column header="Taux en %" field="hospiPourcen" />
            </Row>
        </ColumnGroup>
    );



    const allowExpansion = (rowData) => {
        return rowData.children && rowData.children.length > 0;
    };

    const onRowExpand = (event) => {
    };

    const onRowCollapse = (event) => {
    };


      // Fonction pour exporter en Excel
      const transformData = (data) => {
        return data.map(item => ({
            prestataire: item.statName,
            Total_Montant: item.totalMontant,
            Total_Pourcentage: item.totalPourcent,
            Ambulance_Montant: item.ambuMontant,
            Ambulance_Pourcentage: item.ambuPourcent,
            Hospitalisation_Montant: item.hospiMontant,
            Hospitalisation_Pourcentage: item.hospiPourcent,
            
        }));
    };

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {

            const worksheet = xlsx.utils.json_to_sheet(transformData(statsDatas), { skipHeader: false });
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            saveAsExcelFile(excelBuffer, 'Top_Consommations');
        });
    };
    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    //PDF
    const { toPDF, targetRef } = usePDF({ filename: 'Top_Consommations.pdf',  page:{margin: Margin.SMALL}})
    function exportPDF (){
        setBolPDF(false)
        setTimeout(()=>{
           toPDF()
        }, 300)

        setTimeout(()=>{
        setBolPDF(true)
        }, 500)
    }

    //fichier csv
    const exportToCSVe = (datacsv) => {
        const csvRows = [];
        const headers = [
            'familles',
            'Total '+t("facturation.amount"),
            'Total '+t("common.rate"),
            t("common.ambulatory") +t("facturation.amount"),
            t("common.ambulatory")+t("common.rate"),
            t("common.hospital")+t("facturation.amount"),
            t("common.hospital")+t("common.rate"),
        ];
        csvRows.push(headers.join(','));

        datacsv.forEach(item => {
            const row = [
                item.name,
                item.total.montant,
                item.total.taux,
                item.ambulatoire.montant,
                item.ambulatoire.taux,
                item.hospitalier.montant,
                item.hospitalier.taux
            ];
            csvRows.push(row.join(','));
        });

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', 'Top_Consommations.csv');
        a.click();
    };
    console.log("top consommation etat ")
    console.log(dataHospiSerie2)
    console.log(dataHospiSeries)
    return (
        <>
            {Object.keys(data).length === 0 && <span>
                { t("common.no-data-display")}
            </span>
            }
            {Object.keys(data).length > 0 && <div className='results-section'>
                <div className='row justify-content-center my-4'>
                    <div className='form-group mb-0'>
                        <label className='radio-inline mr-5'>
                            <input type='radio' name='graph' value="hideGraph" checked={!graph} onChange={e => {setGraph(!e.target.checked)}}/> Données
                        </label>
                        <label className='radio-inline'>
                            <input type='radio' name='graph' value="showGraph" checked={graph} onChange={e => {setGraph(e.target.checked)}}/> Graphique
                        </label>
                    </div>
                </div>
                {!graph &&
                 <>
                    <div ref={targetRef}>
                <DataTable 
                    value={statsDatas} 
                    dataKey="id"
                    showGridlines 
                    headerColumnGroup={headerGroup} 
                    tableStyle={{ minWidth: '50rem' }}
                    expandedRows={expandedRows}
                    onRowExpand={onRowExpand} 
                    onRowCollapse={onRowCollapse} 
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    ref={dt}
                >
                    {type === "Famille" && bolPDF && <Column expander={allowExpansion} style={{ width: '5rem' }} />}

                    <Column field="statName"></Column>
                    <Column field="numeroAdherentP"></Column>
                    <Column field="nombreBeneficiare"></Column>
                    <Column field="totalMontant"></Column>
                    <Column field="totalPourcent"></Column>
                    <Column field="ambuMontant"></Column>
                    <Column field="ambuPourcent"></Column>
                    <Column field="hospiMontant"></Column>
                    <Column field="hospiPourcent"></Column>
                </DataTable>
                 </div>
                 <div className="flex align-items-center justify-content-end gap-2">
                     <Button type="button" icon="pi pi-file" rounded onClick={() => exportToCSVe(data)} tooltip="Export CSV" tooltipOptions={{ position: 'top' }} />
                     <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} tooltip="Export XLS" tooltipOptions={{ position: 'top' }} />
                     <Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={() => handlePrint()} tooltip="Export PDF" tooltipOptions={{ position: 'top' }} />
                 </div>
             </>
                }
                {graph && 
                    <div className='row'>
                        <div className='col-15'>
                            <h5>{type === 'Actes' ? t("common.outpatient-act") : t("common.outpatient-cons")}</h5>
                            <HorizontalBarChart series={dataAmbuSeries} labels={dataAmbuLabels} height="150" />
                        </div>
                        <div className='col-15'>
                            <h5>{type === 'Actes' ? t("common.hospi-act") : t("common.hospi-cons")}</h5>
                            <HorizontalBarChart series={dataHospiSeries} labels={dataHospiLabels} height="150" />
                        </div>
                    </div>
                }

                 <div style={{marginTop:100, display:"none" }}>
                    <div style={{ height: "100%", minWidth: '50rem', }} ref={componentRef}>
                        <ExportRapport
                            clientName={clientName}
                            dateMin={dateMin} dateMax={dateMax} nomRapport='topConsommateurs' clientIds={clientIds}
                            data={data} typeRapport="TOP DES CONSOMMATIONS" dataSeries=""
                            dataLabels="" ref={componentRef}
                            headerGroup={headerGroupExport} statsDatas={statsDatas}
                            dataAmbuSeries={dataAmbuSeries} dataAmbuLabels={dataAmbuLabels}
                            dataHospiSeries={dataHospiSerie2}
                            dataHospiLabels={dataHospiLabels} 
                            dt={dt} type={type}
                        />
                    </div>
                </div>

            </div>}
        </>
    )
}
export default EtatsTopConsommations;